var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMyWallet = function SvgMyWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.34,
    height: 22.767,
    viewBox: "0 0 23.34 22.767",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_payment_1393406",
    transform: "translate(-21.66 -21.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10647",
    "data-name": "Path 10647",
    d: "M44.4,29.21l-7.142-6.965a2.094,2.094,0,0,0-2.911,0L22.262,34.03a1.977,1.977,0,0,0,0,2.84L29.4,43.835a2.094,2.094,0,0,0,2.911,0L44.4,32.05A1.977,1.977,0,0,0,44.4,29.21Zm-4.65-3.4L25.918,39.3l-1.477-1.44,13.83-13.489ZM22.844,34.6,34.927,22.813a1.287,1.287,0,0,1,1.747,0l1.015.99L23.859,37.292l-1.015-.99A1.186,1.186,0,0,1,22.844,34.6Zm20.972-3.115L31.733,43.267a1.287,1.287,0,0,1-1.747,0l-3.486-3.4L40.33,26.379l3.486,3.4A1.186,1.186,0,0,1,43.816,31.483Zm-3.692-2.66a2.044,2.044,0,0,0-2.05,1.816,2.012,2.012,0,1,0,2.248,2.191,2.007,2.007,0,0,0-.2-4.007Zm0,3.213c-.44,0-.618-.033-.618.6a1.236,1.236,0,1,1-1.235-1.2c.439,0,.618.033.618-.6a1.236,1.236,0,1,1,1.235,1.2Z",
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-wallet.060483e7.svg";
export { ForwardRef as ReactComponent };